import styled from 'styled-components';

const StyledTriggerWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export default StyledTriggerWrapper;
